// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1bqnY","tab":"Tabs_tab__2bQ4U","tabActive":"Tabs_tabActive__1xBp1"};